import React, { useState } from "react";
import coupleImg from "../../Assets/SignUp/coupleImg.jpeg";
import heading from "../../Assets/SignUp/heading.png";
import bg from "../../Assets/SignUp/bg.png";
import absolute from "../../Assets/SignUp/absolute.png";
import { FaArrowLeftLong } from "react-icons/fa6";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { forgotPassword } from "../../Redux/Actions/AuthAction";
import { CircularProgress } from "@mui/material";
import useTitle from "../../Hooks/useTitle";
import couple1 from "../../Assets/review/db2.jpg"

const Forgotpass = () => {
  useTitle('Forgot Password')
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.Auth);
  const [email, setEmail] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      return toast.error("Email field is required")
    }
    try {
      const res = await dispatch(forgotPassword(email))
      if (!res) {
        return toast.error('something went wrong!!')
      } else {

        toast.success(res.data.message);
        navigate('/check-your-email');
      }

    } catch (error) {
      toast.error(error.response.data.message);
    }
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 h-screen overflow-hidden">
      {/* Left Side Image */}
      <div className="hidden md:flex relative justify-center items-center p-4 h-full overflow-hidden">
        <div className="w-full h-full relative">
          <img
            src={couple1}
            alt="Couple"
            className="w-full h-full object-cover rounded-xl"
          />
          {/* Overlay Content */}
          <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-center text-white">
            <img src={absolute} alt="Decorative Icon" className="mx-auto mb-2" />
            <h1 className="text-3xl  font-bold">USA</h1>
            <h2 className="text-3xl  font-bold">Gujarati Community</h2>
          </div>
        </div>
      </div>

      {/* Right Side Form */}
      <div
        className="flex items-center justify-center h-full w-full p-6 md:p-10"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="w-full max-w-md md:max-w-lg lg:max-w-xl bg-white p-6 md:p-8 rounded-xl">
          <div className="flex justify-center py-5">
            <img src={heading} alt="Matrimony" className="h-10 md:h-12 w-28 md:w-32" />
          </div>
          <h2 className="text-center text-lg md:text-xl font-semibold">Forgot Password?</h2>
          <h3 className="text-center text-md text-gray-500 py-3">No worries, we’ll send you reset instructions.</h3>

          <form className="flex flex-col">
            {/* Email Section */}
            <label className="block font-medium mt-2 mb-1">Email ID</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email id"
              className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#E72848]"
            />

            {/* Reset Password Button */}
            <button
              type="submit"
              className="w-full bg-[#E72848] text-white p-3 my-4 rounded-xl font-semibold hover:bg-[#f53b58] transition duration-300 cursor-pointer flex justify-center"
              onClick={handleResetPassword}
              disabled={loading}
            >
              {
                loading ? <CircularProgress size={24} color="inherit" /> : "Reset Password"
              }
            </button>

            <div className="text-center flex justify-center  gap-3 text-gray-600 cursor-pointer hover:text-gray-800 transition duration-300">
              <FaArrowLeftLong size={20} />
              <NavLink to="/signin" className="text-md text-[#535861] font-medium">Back to Log in</NavLink>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Forgotpass;
